/* tslint:disable */
import {
  RootAccount,
  IncomeInvoice,
  UserProfile,
  LandlordChartOfAccount
} from '../index';

declare var Object: any;
export interface ChartOfAccountInterface {
  "name": string;
  "alias": string;
  "group"?: string;
  "parent_id"?: number;
  "report_type"?: string;
  "editable"?: boolean;
  "item_type_code"?: string;
  "item_class_code"?: string;
  "package_unit_code"?: string;
  "quantity_unit_code"?: string;
  "tax_type_code"?: string;
  "is_commercial"?: boolean;
  "id"?: number;
  "root_account_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  rootAccount?: RootAccount;
  parentAccount?: ChartOfAccount;
  incomeInvoices?: IncomeInvoice[];
  landlords?: UserProfile[];
  landlordChartOfAccount?: LandlordChartOfAccount[];
}

export class ChartOfAccount implements ChartOfAccountInterface {
  "name": string;
  "alias": string;
  "group": string;
  "parent_id": number;
  "report_type": string;
  "editable": boolean;
  "item_type_code": string;
  "item_class_code": string;
  "package_unit_code": string;
  "quantity_unit_code": string;
  "tax_type_code": string;
  "is_commercial": boolean;
  "id": number;
  "root_account_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  rootAccount: RootAccount;
  parentAccount: ChartOfAccount;
  incomeInvoices: IncomeInvoice[];
  landlords: UserProfile[];
  landlordChartOfAccount: LandlordChartOfAccount[];
  constructor(data?: ChartOfAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChartOfAccount`.
   */
  public static getModelName() {
    return "ChartOfAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChartOfAccount for dynamic purposes.
  **/
  public static factory(data: ChartOfAccountInterface): ChartOfAccount{
    return new ChartOfAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChartOfAccount',
      plural: 'ChartOfAccounts',
      path: 'ChartOfAccounts',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "alias": {
          name: 'alias',
          type: 'string'
        },
        "group": {
          name: 'group',
          type: 'string'
        },
        "parent_id": {
          name: 'parent_id',
          type: 'number'
        },
        "report_type": {
          name: 'report_type',
          type: 'string'
        },
        "editable": {
          name: 'editable',
          type: 'boolean',
          default: true
        },
        "item_type_code": {
          name: 'item_type_code',
          type: 'string'
        },
        "item_class_code": {
          name: 'item_class_code',
          type: 'string'
        },
        "package_unit_code": {
          name: 'package_unit_code',
          type: 'string'
        },
        "quantity_unit_code": {
          name: 'quantity_unit_code',
          type: 'string'
        },
        "tax_type_code": {
          name: 'tax_type_code',
          type: 'string'
        },
        "is_commercial": {
          name: 'is_commercial',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "root_account_id": {
          name: 'root_account_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        rootAccount: {
          name: 'rootAccount',
          type: 'RootAccount',
          model: 'RootAccount',
          relationType: 'belongsTo',
                  keyFrom: 'root_account_id',
          keyTo: 'id'
        },
        parentAccount: {
          name: 'parentAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'parent_id',
          keyTo: 'id'
        },
        incomeInvoices: {
          name: 'incomeInvoices',
          type: 'IncomeInvoice[]',
          model: 'IncomeInvoice',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'chart_of_account_id'
        },
        landlords: {
          name: 'landlords',
          type: 'UserProfile[]',
          model: 'UserProfile',
          relationType: 'hasMany',
          modelThrough: 'LandlordChartOfAccount',
          keyThrough: 'landlord_id',
          keyFrom: 'id',
          keyTo: 'chart_of_account_id'
        },
        landlordChartOfAccount: {
          name: 'landlordChartOfAccount',
          type: 'LandlordChartOfAccount[]',
          model: 'LandlordChartOfAccount',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'chart_of_account_id'
        },
      }
    }
  }
}
